<template>
  <div>
    <BaseIcon class="base-spinner-big" name="spinner-big"/>
  </div>
</template>

<script>
  export default {
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  
  @keyframes loading {
    to {
      transform: rotate(1turn);
    }
  }

  .base-spinner-big {
    animation: loading .5s linear infinite;
    height: 44px;
    width: 44px;
    color: $color-puerto-rico;
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseSpinnerBig.vue